import { render, staticRenderFns } from "./ViewSetting.vue?vue&type=template&id=1a0a525e&scoped=true&"
import script from "./ViewSetting.vue?vue&type=script&lang=js&"
export * from "./ViewSetting.vue?vue&type=script&lang=js&"
import style0 from "./ViewSetting.vue?vue&type=style&index=0&id=1a0a525e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a525e",
  null
  
)

export default component.exports